// extracted by mini-css-extract-plugin
var _1 = "Q0K3G";
var _2 = "FLwLv";
export { _1 as "icon", _2 as "root" }
